export enum OutlineDirection {
    Left = 1,
    Middle = 2,
    Right = 3
};